<div class="relative w-full h-full bg-gray-100">
  <div #editor class="absolute inset-10 bg-white border rounded shadow transition-colors" [ngClass]="{ '!border-gray-400': !invalid, '!border-red-600': invalid, 'opacity-50 pointer-events-none': disabled }"></div>
</div>
